import { render, staticRenderFns } from "./Rede.vue?vue&type=template&id=aece0c66&"
import script from "./Rede.vue?vue&type=script&lang=js&"
export * from "./Rede.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports